import React from "react";
import { RedocStandalone } from "redoc";
import "./Redoc.css";

const Redoc = ({ specUrl }) => {
  return (
    <RedocStandalone
      specUrl={specUrl}
      options={{
        nativeScrollbars: false,
        hideDownloadButton: true,
        noAutoAuth: true,
        expandDefaultServerVariables: true,
        onlyRequiredInSamples: false,
        hideLoading: true,
        expandResponses: "200",
        theme: {
          colors: {
            primary: {
              main: "#474e54",
            },
          },
          typography: {
            links: {
              color: "#0366d6",
              hover: "#e53935",
              visited: "#CBC3E3",
            },
          },
          spacing: {
            sectionVertical: 20,
          },
        },
      }}
    />
  );
};

export default Redoc;
